import { SpyneTrait } from 'spyne';

export class FullscreenNullViewTraits extends SpyneTrait {
  constructor(context) {
    let traitPrefix = 'fullscreenNullView$';
    super(context, traitPrefix);
  }

  // The whole page goes fullscreen, so the layout and its width are unchanged.
  static fullscreenNullView$OnEnter() {
    const request = document.documentElement.requestFullscreen?.();
    request?.catch(() => this.fullscreenNullView$ReportState());
  }

  static fullscreenNullView$OnExit() {
    if (Boolean(document.fullscreenElement) === false) {
      this.fullscreenNullView$ReportState();
      return;
    }
    document.exitFullscreen().catch(() => this.fullscreenNullView$ReportState());
  }

  // fullscreenchange fires for every exit path, including Esc.
  static fullscreenNullView$OnBrowserChange() {
    this.fullscreenNullView$ReportState();
  }

  static fullscreenNullView$ReportState() {
    this.sendInfoToChannel(
      'CHANNEL_FULLSCREEN',
      { isFullscreen: Boolean(document.fullscreenElement) },
      'CHANNEL_FULLSCREEN_STATE_REQUEST',
    );
  }
}
